module.exports = __webpack_public_path__ + "img/32.60847fad.jpg";